import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlayerInfo, PlayerdashboardCount, SubscriptionOptions, TransactionHistory, UserCard } from '../models';
import { HttpService } from './http.service';

@Injectable()
export class PlayerDashboardService {

  private api = '/api/Player';
  public parentDetails: { [parentId: string]: any } = {};
  links: { title: string; url: any; }[];
  constructor(
    private http: HttpClient,
    private bs: HttpService
  ) { }

  isPlayerRegisteredWithOrg(playerID: string) {
    return this.http.get<any>(this.api + '/is-player-registered-with-org/' + playerID);
  }

  getUnreadMessageCounts(playerID: string) {
    return this.http.get<any>(this.api + '/get-photo-and-unread-message-counts/' + playerID);
  }

  getPlayerInfo(playerID: string) {
    return this.http.get<PlayerInfo>(this.api + '/get-player-info/' + playerID);
  }

  getPlayerDashboardTopData(playerID: number) {
    return this.http.get<PlayerdashboardCount>(this.api + '/get-player-dashboard-top-data/' + playerID);
  }

  getPlayerSubscriptionOptionsToUpgrade(playerID: number) {
    return this.http.get<SubscriptionOptions>(this.api + '/get-player-subscription-options-upgrade/' + playerID);
  }

  getPlayerTransactionHistory(playerID: number) {
    return this.http.get<TransactionHistory>(this.api + '/get-player-transaction-history/' + playerID);
  }

  addNewCard(cardData: any) {
    return this.http.post(this.api + '/addNewCard/', cardData, { responseType: 'text' });
  }

  getSavedCardsDetails(playerID: number) {
    return this.http.get<UserCard>(this.api + '/getSavedCardsDetails/' + playerID);
  }

  playerUpgrade(upgradeData: any) {
    return this.http.post(this.api + '/player-upgrade/', upgradeData, { responseType: 'text' });
  }

  getForms(clubID: number, userID: number) {
    return this.bs.get(`${this.api}/forms/${clubID}/${userID}`);
  }

  getPlayerFormByPlayerID(playerID: number, clubID: number) {
    return this.bs.get(`${this.api}/get-player-form-by-playerID/${playerID}/${clubID}`);
  }

  getPlayerFormByPlayerIDClubID(playerID: number, clubID: number) {
    return this.bs.get(`${this.api}/get-player-form-by-playerID-and-clubID/${playerID}/${clubID}`);
  }

  getStaffUserFormByStaffUserID(staffuserID: number, clubID: number) {
    return this.bs.get(`${this.api}/get-staff-user-form-by-staffuserID/${staffuserID}/${clubID}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/player-dashboard.service.ts